import React from "react"
import SearchResult from "../../../templates/newhomes-result-template"
import {SearchTitle, PropertySearchURL} from "../../../common/constant"


// markup
const PropertForSale = (props) => {
  return (
    <SearchResult 
      title={SearchTitle.residential.newdevelopments} 
      department={"residential"} 
      search_type={"newdevelopments"} 
      status={['For Sale']} 
      path={PropertySearchURL["residential"]["newdevelopments"]}
      location={props.location}
    />
  )
}

export default PropertForSale